import gatosOrange from '../assets/images/gatosOrange.jpg';
import houseOfBlues from '../assets/images/houseOfBlues.jpg';

import Bio from '../components/bio.tsx'
import Performances from '../components/performances.tsx';
import { Icon } from '../components/ui/icon.js';
import YoutubeEmbed from '../components/youtubeEmbed.tsx';
import { type Route } from './+types/presskit.ts'

export function meta({ matches }: Route.MetaArgs) {
  const rootMatch = (matches as any[]).find(m => m.id === 'root')
  const rootMeta = (rootMatch?.meta ?? []) as Array<Record<string, string>>
  const { origin, path } = rootMatch?.loaderData?.requestInfo ?? {}
  const inherited = rootMeta.filter(m => !('title' in m) && !(m.name === 'description') && !(m.property === 'og:url'))
  return [
    ...inherited,
    { title: "Rohna | Press kit" },
    { name: "description", content: "Discover Rohna - Tampa, Florida's rising Indie Alternative Rock band! Catch them live at a venue or festival near you as they take on some of the most iconic stages across the country. Stream and download their music on all platforms!" },
    { property: "og:title", content: "Rohna" },
    { property: 'og:url', content: `${origin}${path}` },
    { property: "og:description", content: "Discover Rohna - Tampa, Florida's rising Indie Alternative Rock band! Catch them live at a venue or festival near you as they take on some of the most iconic stages across the country. Stream and download their music on all platforms!" },
  ]
}

export default function PressKit() {
  return (
    <div id="epk" className="">
      <h1 className="text-center py-8 lg:py-16 text-5xl lg:text-7xl lg:text-left lg:ml-8 font-extrabold uppercase">Press Kit</h1>
      <section id="bio" className='bg-white text-black flex flex-col xl:flex-row items-center justify-center text-left px-4 xl:px-0 pt-8 pb-16'>
        <div className="xl:mx-8 w-full xl:w-1/2">
        <img src={gatosOrange} className="rounded-2xl object-contain" alt="The band arranged in front of an orange steel storage building outside amongst desert scenery."></img>
        </div>
        <div className="text-base font-normal m-8 xl:my-0 w-full xl:w-1/2">
          <h2 className="text-left pb-8 text-4xl font-bold">Bio</h2>
          <Bio />
        </div>
      </section>
      <section id="stats" className="mx-8 py-16">
        <div className="">
          <h2 className="text-left pb-4 text-4xl font-bold">Stats</h2>

          <div className="flex flex-col gap-4 xl:grid xl:grid-cols-5 xl:gap-6">
            <div id="spotifyCard" className="col-span-1 row-span-2 p-4 bg-white/10 rounded-xl">
              <h3 className="sr-only">Spotify</h3>
              <div className="h-full flex flex-col justify-between gap-8 xl:gap-0">
                <a href="https://open.spotify.com/artist/7yH9wdVRj7Po5vpa19yNC2?si=HIud4zziRW2rtxDE0Wz2BA" aria-label="Spotify (opens in new tab)" target="_blank" rel="noopener noreferrer">
                  <Icon name="spotify" title="Spotify" size="xl" className="hover:scale-105"></Icon>
                </a>
                <div className="flex flex-col justify-end h-full gap-1">
                  <h4 className="font-normal text-base">Followers</h4>
                  <p className="font-bold text-5xl">8000+</p>
                  <h4 className="font-normal text-base">“Nowhere Else to Go”</h4>
                  <p className="font-bold text-5xl">960k+</p>
                  <h4 className="font-normal text-base">“Don't Come Down”</h4>
                  <p className="font-bold text-5xl">280k+</p>
                </div>
              </div>
            </div>

            <div id="instagramCard" className="col-span-1 col-start-2 p-4 bg-white/10 rounded-xl">
              <div className="h-full flex flex-col justify-between gap-8 xl:gap-0">
                <a href="https://www.instagram.com/rohnamusic" aria-label="Instagram (opens in new tab)" target="_blank" rel="noopener noreferrer">
                  <Icon name="instagram" title="Instagram" size="xl" className="hover:scale-105"></Icon>
                </a>
                <div className="flex flex-col justify-end h-full gap-1">
                  <h3 className="sr-only">Instagram</h3>
                    <h4 className="font-normal text-base">Followers</h4>
                    <p className="font-bold text-5xl">13k+</p>
                </div>
              </div>
            </div>

            <div id="tiktokCard" className="col-span-1 col-start-2 row-start-2 p-4 bg-white/10 rounded-xl">
              <div className="h-full flex flex-col justify-between gap-8 xl:gap-0">
                <a href="https://www.tiktok.com/@rohnamusic" aria-label="TikTok (opens in new tab)" target="_blank" rel="noopener noreferrer">
                  <Icon name="tiktok" title="TikTok" size="xl" className="hover:scale-105"></Icon>
                </a>
                <div className="flex flex-col justify-end h-full gap-1">
                  <h3 className="sr-only">TikTok</h3>
                    <h4 className="font-light text-base">Followers</h4>
                    <p className="font-bold text-5xl">14k+</p>
                    <h4 className="font-normal text-base">Likes</h4>
                    <p className="font-bold text-5xl">830k+</p>
                </div>
              </div>
            </div>

            <div id="spotifyPlayer" className="col-span-3 row-span-2">
              <h2 className="sr-only">Spotify Player</h2>
              <iframe title="Rohna on Spotify" src="https://open.spotify.com/embed/artist/7yH9wdVRj7Po5vpa19yNC2?utm_source=generator&theme=0" width="100%" height="400"></iframe>
            </div>

          </div>
        </div>
      </section>
      <section id="performances" className="bg-white text-black 2xl:min-h-fit py-16 px-4 md:px-8 flex flex-col xl:flex-row xl:justify-evenly">
        <div className="hidden xl:block xl:w-1/4 xl:self-center">
          <img src={houseOfBlues} className="rounded-2xl" alt="Band performing in front of a large crowd at the House of Blues in Orlando, FL."></img>
        </div>
        <div className="self-start text-base font-normal w-full pl-0 xl:pl-8 xl:py-4 xl:w-2/3">
          <h2 className="text-center xl:text-left pb-4 text-4xl font-bold">Notable Performances</h2>
          <Performances />
        </div>
      </section>
      <section id="videos" className="py-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-0 justify-center lg:justify-around items-center">
          <div>
            <h2 className="text-left pb-4 text-4xl font-bold">Live</h2>
            <YoutubeEmbed url={'g_TtuLl9fAE?si=0KcSvLHNf2yqkKJ7'} title="Live Video" className="w-[300px] h-[200px] md:w-[400px] md:h-[300px] xl:w-[560px] xl:h-[315px]"/>
          </div>
          <div>
            <h2 className="text-left pb-4 text-4xl font-bold">Latest Music Video</h2>
            <YoutubeEmbed url={'M-ZrIAOr4Tw?si=Xh4lIM_j_d4rHrN0'} title="Latest Music Video" className="w-[300px] h-[200px] md:w-[400px] md:h-[300px] xl:w-[560px] xl:h-[315px]"/>
          </div>
        </div>
      </section>
      <section id="contact" className='flex flex-col items-center justify-center text-center gap-16 py-24 bg-orange rounded-t-xl'>
        <div className="text-base text-center font-normal m-8 lg:my-0 lg:w-1/2 md:5/8">
          <h2 className="pb-8 text-4xl font-bold">Contact Us</h2>
          <p className="italic">For all inquiries, email us at:</p>
          <a className="block text-lg md:text-2xl font-semibold cursor-pointer transition-all hover:scale-105" href="mailto:rohna.music@gmail.com">rohna.music@gmail.com</a>
        </div>
      </section>
    </div>
  );
}